(function ($) {
    $(document).ready(function () {
        extraServices();
    });

    function extraServices() {
        var wrap = $('.section.services_grid .list');

        if (wrap.length > 0) {
            wrap.each(function () {
                var single_wrap = $(this);
                single_wrap.on("init", function () {
                    lazyLoadInstance.update();
                });
                single_wrap.slick({
                    autoplay: false,
                    arrows: true,
                    dots: true,
                    infinite: true,
                    prevArrow: accor_arrow_prev,
                    nextArrow: accor_arrow_next,
                    appendDots: wrap.closest('.section').find('.pager'),
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    centerMode: true,
                    centerPadding: '30%',
                    adaptiveHeight: false,
                    rtl: $('html').attr('dir') === 'rtl',
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                centerPadding: '20%'
                            },
                        },
                        {
                            breakpoint: 1025,
                            settings: {
                                dots: false,
                                centerMode: false,
                            }
                        },

                    ]
                });
            })
        }
    }

})(jQuery);